import { SVGProps } from 'react'

export const CommentOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <g>
      <path
        fill="#05155E"
        d="M16.666 14.308l-.975-.975H3.333v-10h13.333v10.975zm0-12.641H3.333c-.917 0-1.667.75-1.667 1.666v10c0 .917.75 1.667 1.667 1.667H15l3.333 3.333v-15c0-.916-.75-1.666-1.666-1.666z"
      ></path>
    </g>
  </svg>
)
